/* global BigInt */

export const addBasePrefix = (num, base) => {
    if (!num) {
        return 0;
    }

    const baseConversion = {
        2: `0b${num}`,
        8: `0o${num}`,
        16: `0x${num}`,
        10: num,
    };

    return baseConversion[base];
};

export const hexToInt = (hex) => {
    const hexNewCurrResult = convertToNon10Base(hex, 16, 2);
    return binaryToInt(hexNewCurrResult);
};

export const octToInt = (oct) => {
    const octNewCurrResult = convertToNon10Base(oct, 8, 2);
    return binaryToInt(octNewCurrResult);
};

export const binaryToInt = (binary) => {
    const unsignedResult = addBasePrefix(binary, 2);
    const [result] = (binary && new Int32Array([unsignedResult])) || [];
    return result;
};

export const convertToNon10Base = (number, oldBase, newBase) => {
    if (!number) {
        return;
    }

    return BigInt(addBasePrefix(number, oldBase)).toString(newBase).toUpperCase();
};

export const intToBase = (num, base) => {
    if (num === undefined || num === null) {
        return;
    }

    return (num >>> 0)?.toString(base)?.toUpperCase();
};

export const baseToIntConvertFunction = {
    2: binaryToInt,
    8: octToInt,
    16: hexToInt,
};
